<template>
  <div class="profile">
    <TopNavigation activeApp="Ops Portal User Profile"/>

    <div v-if="userSignedIn">
      <h1 >Welcome, {{userName}}</h1>
      <div>
        Application access:
          <div v-for="(application, index) in userApplications" 
            v-bind:group="application"
            v-bind:index="index"
            v-bind:key="application.id"          
            >{{application}}
            <br/>
            </div>
      </div>
      <hr>
      <div class="mt-3">
        <MfaSelect/>
      </div>
      <hr>

    </div>

    <h1 v-else>Not signed in.</h1>
  </div>
</template>

<script>
//import { Auth } from 'aws-amplify'
import { mapGetters } from 'vuex'
import TopNavigation from '@/components/TopNavigation.vue'
import MfaSelect from '@/components/auth/MfaSelect.vue'

export default {
  name: 'Profile',
  components: {
    TopNavigation,
    MfaSelect
  },
  data() {
    return {
    }
  },
  computed: {
    ...mapGetters('authstore', {
      userSignedIn: 'userSignedIn',
      userName: 'userName',
      userApplications: 'userApplications'
    })
  },
}
</script>

